import { RevenueData } from "../../../../types/api/dashboard";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const RevenueChart = ({revenueData} : {revenueData: RevenueData[]}) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={revenueData}>
        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          stroke="#f1f5f9"
        />

        <XAxis
          dataKey="month"
          tick={{ fontSize: 12 }}
          axisLine={false}
          tickLine={false}
        />

        <YAxis
          tick={{ fontSize: 12 }}
          axisLine={false}
          tickLine={false}
          tickFormatter={(value) => `£${value}k`}
        />

        <Tooltip />

        <Bar
          dataKey="revenue"
          fill="var(--color-primary)"
          radius={[6, 6, 0, 0]}
          name="Revenue"
        />

<Legend wrapperStyle={{ fontSize: "11px" }} />
      </BarChart>
    </ResponsiveContainer>
  );
};


export default RevenueChart